import { Injectable } from '@angular/core';
import { RawScheduleOwner, ScheduleOwnerFacade } from '@mode/shared/schedules/contract';

@Injectable()
export class ScheduleOwnerFacadeService extends ScheduleOwnerFacade {
  public rawScheduleOwner: RawScheduleOwner = {} as unknown as RawScheduleOwner;
  public loadOwner(rawScheduleOwner: RawScheduleOwner) {
    this.rawScheduleOwner = rawScheduleOwner;
  }
  public get authorizedDomains() {
    return this.rawScheduleOwner.authorized_domains;
  }

  public get emailAttachmentsEnabled() {
    return this.rawScheduleOwner?._resource?.settings.email_attachments_enabled ?? false;
  }

  public get orgToken() {
    return this.rawScheduleOwner.token;
  }
}
